module.exports = __webpack_public_path__ + "img/ES-M-6.7e92cb40.svg";